import { useState, useEffect } from "react";
import TopMenu from "../TopMenu/TopMenu";
import SideMenu from "../SideMenu/SideMenu";
import { Outlet } from "react-router-dom";
import { RoomManagerProvider } from "../../components/RoomManager";

const MainLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  return (
    <RoomManagerProvider>
      <div className="dark:bg-boxdark-2 dark:text-bodydark">
        <div className="flex h-screen overflow-hidden">
          <SideMenu sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

          <div className="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden">
            <TopMenu sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

            <main className="h-full overflow-y-auto bg-[#F5F7F9]">
              <div className="mx-auto w-full py-4 px-4 md:px-8">
                <Outlet />
                {children}
              </div>
            </main>
          </div>
        </div>
      </div>
    </RoomManagerProvider>
  );
};

export default MainLayout;
